import { XferOperationStatus } from '../shared/models/xfer.model';

export function compatImportStatus(status: XferOperationStatus): XferOperationStatus {
  if (status === XferOperationStatus.Canceling) {
    return XferOperationStatus.Cancelling;
  }

  if (status === XferOperationStatus.Canceled) {
    return XferOperationStatus.Cancelled;
  }

  return status;
}

